import apiURL from'./apiURL';
// const apiURL = `http://localhost:3000`;

// types of action
const Types = {
  VIDEO_MODAL: "VIDEO_MODAL",
};

const showVideoModal = status => ({
  type: Types.VIDEO_MODAL,
  status
});


const Actions = {
  showVideoModal,
};


export {Types, Actions}